import React from 'react';
import ReactDOM from 'react-dom';
import './css/styles.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.querySelector('.app'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js